/* AUTO GENERATED FILE. DO NOT MODIFY DIRECTLY!!!*/

export enum T {
  ADD_MEDIA_LABEL = 'add_media_label',
  ADD_AUDIO_LABEL = 'add_audio_label',
  AI_IMAGE_LABEL = 'ai_image_label',
  AI_VIDEO_LABEL = 'ai_video_label',
  AI_AVATAR_LABEL = 'ai_avatar_label',
  ADD_AVATAR_LABEL = 'add_avatar_label',
  PUBLIC_AVATARS_LABEL = 'public_avatars_label',
  SELECT_FROM_PUBLIC_AVATARS_LABEL = 'select_from_public_avatars_label',
  VOICES_LABEL = 'voices_label',
  VOICE_LIBRARY_LABEL = 'voice_library_label',
  VOICE_CLONE_LABEL = 'voice_clone_label',
  ADD_VOICE_FILE_LABEL = 'add_voice_file_label',
  MY_VOICES_LABEL = 'my_voices_label',
  UPLOADING_YOUR_VOICE_LABEL = 'uploading_your_voice_label',
  UPLOAD_OR_DRAG_DROP_VOICE_LABEL = 'upload_or_drag_drop_voice_label',
  CONFIRM_VOICE_OWNERSHIP_TITLE = 'confirm_voice_ownership_title',
  CONFIRM_VOICE_OWNERSHIP_DESCRIPTION = 'confirm_voice_ownership_description',
  CONFIRM_LABEL = 'confirm_label',
  VOICE_UPLOAD_FAILED_TITLE = 'voice_upload_failed_title',
  VOICE_UPLOAD_FAILED_DESCRIPTION = 'voice_upload_failed_description',
  TRY_AGAIN_LABEL = 'try_again_label',
  SPEECH_LABEL = 'speech_label',
  SELECT_AVATAR_AND_ENTER_SPEECH_TOOLTIP = 'select_avatar_and_enter_speech_tooltip',
  ENTER_SPEECH_TEXT_TOOLTIP = 'enter_speech_text_tooltip',
  SELECT_AVATAR_TOOLTIP = 'select_avatar_tooltip',
  SPEECH_PLACEHOLDER = 'speech_placeholder',
  UPGRADE_FOR_LONGER_VIDEOS = 'upgrade_for_longer_videos',
  FREE_TRIAL_LABEL = 'free_trial_label',
  NEED_LONGER_VIDEO_LABEL = 'need_longer_video_label',
  UPLOAD_LABEL = 'upload_label',
  UPLOAD_LABEL_SIDEBAR = 'upload_label_sidebar',
  MY_FILES_LABEL = 'my_files_label',
  AI_CHARACTERS_LABEL = 'ai_characters_label',
  RECENT_MEDIAS_LABEL = 'recent_medias_label',
  EXPORT_LABEL = 'export_label',
  MY_ACCOUNT_LABEL = 'my_account_label',
  HELP_AND_SUPPORT_LABEL = 'help_and_support_label',
  SIGN_OUT_LABEL = 'sign_out_label',
  VIDEOS_LABEL = 'videos_label',
  IMAGES_LABEL = 'images_label',
  LANGUAGE_LABEL = 'language_label',
  CREATED_IN_THIS_PROJECT_LABEL = 'created_in_this_project_label',
  EXPORT_DESCRIPTION_720 = 'export_description_720',
  EXPORT_DESCRIPTION_1080 = 'export_description_1080',
  EXPORT_DESCRIPTION_2160 = 'export_description_2160',
  PROJECT_DURATION_WARNING_MESSAGE = 'project_duration_warning_message',
  PROJECT_BETA_VERSION_DURATION_WARNING_MESSAGE = 'project_beta_version_duration_warning_message',
  OK_THANKS_LABEL = 'ok_thanks_label',
  SPLIT_LABEL = 'split_label',
  DELETE_LABEL = 'delete_label',
  DUPLICATE_LABEL = 'duplicate_label',
  ROTATE_LEFT_LABEL = 'rotate_left_label',
  ROTATE_RIGHT_LABEL = 'rotate_right_label',
  FIT_LABEL = 'fit_label',
  FILL_LABEL = 'fill_label',
  LAYER_ORDER_MENU_LABEL = 'layer_order_menu_label',
  AUDIO_LABEL = 'audio_label',
  TEXT_LABEL = 'text_label',
  SEARCH_MUSIC_LABEL = 'search_music_label',
  MY_MUSIC_LABEL = 'my_music_label',
  MUSIC_LIBRARY_LABEL = 'music_library_label',
  MORE_ACTIONS_LABEL = 'more_actions_label',
  GENERATE_LABEL = 'generate_label',
  RESET_LABEL = 'reset_label',
  HISTORY_EMPTY_TITLE = 'history_empty_title',
  HISTORY_EMPTY_DESCRIPTION = 'history_empty_description',
  HISTORY_EMPTY_DESCRIPTION_AI_VIDEO = 'history_empty_description_ai_video',
  ADD_TO_TIMELINE = 'add_to_timeline',
  OOPS_NOTHING_HERE = 'oops_nothing_here',
  DRAG_AND_DROP_A_FILE_OR_USE_UPLOAD_BUTTON = 'drag_and_drop_a_file_or_use_upload_button',
  YES_DROP_IT = 'yes_drop_it',
  CREATE_SIMILAR = 'create_similar',
  RE_GENERATE = 're_generate',
  USE_AS_REFERENCE = 'use_as_reference',
  ANIMATE = 'animate',
  DOWNLOAD = 'download',
  TTS_DOWNLOAD_DISABLED_TOOLTIP = 'tts_download_disabled_tooltip',
  TTS_DOWNLOAD_ACTIVE_TOOLTIP = 'tts_download_active_tooltip',
  YES_DROP_LABEL = 'yes_drop_label',
  DRAG_DROP_TEXT = 'drag_drop_text',
  OR_LABEL = 'or_label',
  REMOVE_SOUND_FROM_LIBRARY = 'remove_sound_from_library',
  EDIT_LABEL = 'edit_label',
  DELETE_SOUND_FROM_LIBRARY_WARNING_MESSAGE = 'delete_sound_from_library_warning_message',
  CLOSE_LABEL = 'close_label',
  CHARACTERS_ADVISED_LABEL = 'characters_advised_label',
  PREVIEW = 'preview',
  IMAGE_PROMPT_TITLE = 'image_prompt_title',
  PROMPT_PLACEHOLDER = 'prompt_placeholder',
  MENTION_IMAGE_LABEL = 'mention_image_label',
  PROMPT_PLACEHOLDER_RESTYLE = 'prompt_placeholder_restyle',
  PROMPT_PLACEHOLDER_LIGHTING = 'prompt_placeholder_lighting',
  PROMPT_PLACEHOLDER_PRODUCT = 'prompt_placeholder_product',
  VIDEO_PROMPT_PLACEHOLDER_ANIMATE = 'video_prompt_placeholder_animate',
  VIDEO_PROMPT_PLACEHOLDER_COMBINE = 'video_prompt_placeholder_combine',
  VIDEO_PROMPT_PLACEHOLDER_MOTION = 'video_prompt_placeholder_motion',
  MODEL_LABEL = 'model_label',
  ASPECT_RATIO_LABEL = 'aspect_ratio_label',
  ADD_REFERENCE_MULTIPLE_IMAGES_TITLE = 'add_reference_multiple_images_title',
  ADD_REFERENCE_SINGLE_IMAGE_TITLE = 'add_reference_single_image_title',
  TEXT_TO_SPEECH_LABEL = 'text_to_speech_label',
  COMPLETED = 'completed',
  INACTIVE_GENERATE_BUTTON_TOOLTIP = 'inactive_generate_button_tooltip',
  WEEKLY_LITE_USER_TTS_LIMIT = 'weekly_lite_user_tts_limit',
  SUBSCRIBED_USER_TTS_CREDIT_LIMIT = 'subscribed_user_tts_credit_limit',
  FREE_USER_TTS_CREDIT_LIMIT = 'free_user_tts_credit_limit',
  TTS_CREDIT_LIMIT_EXPIRING_WARNING = 'tts_credit_limit_expiring_warning',
  CONTACT_SUPPORT = 'contact_support',
  NO_SEARCH_RESULT_DESCRIPTION = 'no_search_result_description',
  SELECT_LABEL = 'select_label',
  STYLES_LABEL = 'styles_label',
  TYPE_LABEL = 'type_label',
  CHARACTERS_LABEL = 'characters_label',
  RESTYLE_LABEL = 'restyle_label',
  SOMETHING_WENT_WRONG_LABEL = 'something_went_wrong_label',
  GOT_IT_LABEL = 'got_it_label',
  NOT_FOUND_PROJECT_ERROR_MESSAGE = 'not_found_project_error_message',
  GENERAL_API_ERROR_MESSAGE = 'general_api_error_message',
  VOICE = 'voice',
  SPEAKER_TONE_TOOLTIP_TEXT = 'speaker_tone_tooltip_text',
  SPEAKER_TOGGLER_TOOLTIP_TEXT = 'speaker_toggler_tooltip_text',
  TTS_VOICE_TONE = 'tts_voice_tone',
  MULTILINGUAL_LANGUAGE_TOOLTIP = 'multilingual_language_tooltip',
  TTS_DELETE_TOOLTIP = 'tts_delete_tooltip',
  TTS_TEXTS_TOOLTIP = 'tts_texts_tooltip',
  DEFAULT_SPEAKER = 'default_speaker',
  DEFAULT_SPEAKER_TOOLTIP = 'default_speaker_tooltip',
  SPEED = 'speed',
  CHANGE_SPEED = 'change_speed',
  SET_VOICE_TONE = 'set_voice_tone',
  SET_VOICE_TONE_TOOLTIP = 'set_voice_tone_tooltip',
  MALE = 'male',
  FEMALE = 'female',
  BACK = 'back',
  SAVE = 'save',
  CANCEL = 'cancel',
  SAVE_CHANGES_ALERT_TOOLTIP = 'save_changes_alert_tooltip',
  TEXTS = 'texts',
  CHANGE_SPEAKER = 'change_speaker',
  EDIT_AUDIO = 'edit_audio',
  VOLUME = 'volume',
  REMOVE = 'remove',
  VERSIONS = 'versions',
  TRACK = 'track',
  SECOND = 'second',
  MINUTE = 'minute',
  SECONDS = 'seconds',
  MINUTES = 'minutes',
  PROMPT = 'prompt',
  EDIT_AI_IMAGE = 'edit_ai_image',
  CANCEL_LABEL = 'cancel_label',
  EXPORT_DISABLE_LABEL = 'export_disable_label',
  SOURCE_LABEL = 'source_label',
  PROJECT_MAX_DURATION_EXCEEDED_TITLE = 'project_max_duration_exceeded_title',
  PROJECT_MAX_DURATION_EXCEEDED_DESCRIPTION = 'project_max_duration_exceeded_description',
  AI_VIDEO_GENERATION_FAILED_TITLE = 'ai_video_generation_failed_title',
  AI_VIDEO_GENERATION_FAILED_DESCRIPTION = 'ai_video_generation_failed_description',
  AI_AVATAR_GENERATION_FAILED_DESCRIPTION = 'ai_avatar_generation_failed_description',
  GENERATION_FAILED = 'generation_failed',
  AI_IMAGE_GENERATION_FAILED_DESCRIPTION = 'ai_image_generation_failed_description',
  AI_MODERATION_FAILED_TITLE = 'ai_moderation_failed_title',
  AI_MODERATION_FAILED_DESCRIPTION = 'ai_moderation_failed_description',
  AI_VIDEO_TEMPORARILY_UNAVAILABLE_TITLE = 'ai_video_temporarily_unavailable_title',
  AI_VIDEO_TEMPORARILY_UNAVAILABLE_DESCRIPTION = 'ai_video_temporarily_unavailable_description',
  GET_MORE_MINUTES = 'get_more_minutes',
  ADD = 'add',
  TYPE_YOUR_TEXT = 'type_your_text',
  TTS_GENERATION_ERROR_DESCRIPTION = 'tts_generation_error_description',
  TTS_TRIAL_LANGUAGE_MISMATCH_WARNING = 'tts_trial_language_mismatch_warning',
  AVATAR_LANGUAGE_MISMATCH_TITLE = 'avatar_language_mismatch_title',
  AVATAR_LANGUAGE_MISMATCH_DESCRIPTION = 'avatar_language_mismatch_description',
  GO_BACK_LABEL = 'go_back_label',
  GENERATE_ANYWAY_LABEL = 'generate_anyway_label',
  ADD_PROMPT_OR_REFERENCE_IMAGE_TO_GENERATE = 'add_prompt_or_reference_image_to_generate',
  ADD_PROMPT_OR_START_FRAME_TO_GENERATE = 'add_prompt_or_start_frame_to_generate',
  SUPPORTED_FILE_TYPES_WARNING = 'supported_file_types_warning',
  UNSUPPORTED_FILE_FORMAT_DESCRIPTION = 'unsupported_file_format_description',
  ENTER_PROMPT_TO_GENERATE = 'enter_prompt_to_generate',
  REFERENCE_IMAGE_RESIZE_CREDITS = 'reference_image_resize_credits',
  REFERENCE_IMAGES_RESIZE_CREDITS = 'reference_images_resize_credits',
  UNDO = 'undo',
  REDO = 'redo',
  AI_CREDITS_LABEL = 'ai_credits_label',
  REFILL_CREDITS_LABEL = 'refill_credits_label',
  REFILL_LABEL = 'refill_label',
  DISCOUNT_LABEL = 'discount_label',
  SWITCH_TO_WIDESCREEN_TITLE = 'switch_to_widescreen_title',
  SWITCH_TO_VERTICAL_TITLE = 'switch_to_vertical_title',
  SWITCH_TO_PORTRAIT_TITLE = 'switch_to_portrait_title',
  SWITCH_TO_SQUARE_TITLE = 'switch_to_square_title',
  SWITCH_TO_STANDARD_TITLE = 'switch_to_standard_title',
  SWITCH_TO_CLASSIC_TITLE = 'switch_to_classic_title',
  SWITCH_TO_ORIGINAL_TITLE = 'switch_to_original_title',
  SWITCH_CANVAS_SIZE_TITLE = 'switch_canvas_size_title',
  ASPECT_RATIO_WARNING_DESCRIPTION = 'aspect_ratio_warning_description',
  SWITCH_LABEL = 'switch_label',
  WIDESCREEN_LABEL = 'widescreen_label',
  PORTRAIT_LABEL = 'portrait_label',
  VERTICAL_LABEL = 'vertical_label',
  SQUARE_LABEL = 'square_label',
  STANDARD_LABEL = 'standard_label',
  CLASSIC_LABEL = 'classic_label',
  UP_TO_LABEL = 'up_to_label',
  LET_S_CREATE_SOMETHING_AMAZING_LABEL = 'let_s_create_something_amazing_label',
  GENERATE_AI_VIDEO_LABEL = 'generate_ai_video_label',
  GENERATE_AI_IMAGE_LABEL = 'generate_ai_image_label',
  AI_CREATES_VIDEO_LABEL = 'ai_creates_video_label',
  AI_CREATES_IMAGE_LABEL = 'ai_creates_image_label',
  UPLOAD_YOUR_MEDIA_LABEL = 'upload_your_media_label',
  CONSISTENCY_DISABLED_FIELD_TOOLTIP = 'consistency_disabled_field_tooltip',
  SELECT_MODEL_TO_GENERATE_TOOLTIP = 'select_model_to_generate_tooltip',
  SELECT_VIDEO_MODEL_TOOLTIP = 'select_video_model_tooltip',
  SELECT_MODEL_PLACEHOLDER = 'select_model_placeholder',
  VIDEO_MODELS_FREE_SECTION = 'video_models_free_section',
  VIDEO_MODELS_PREMIUM_SECTION = 'video_models_premium_section',
  VIDEO_MODEL_PICK_FOR_LABEL = 'video_model_pick_for_label',
  VIDEO_MODEL_QUALITY_LABEL = 'video_model_quality_label',
  CREDIT_FREE_LABEL = 'credit_free_label',
  CREDIT_FROM_LABEL = 'credit_from_label',
  VIDEO_PICK_FOR_RENDERFOREST = 'video_pick_for_renderforest',
  VIDEO_PICK_FOR_SEEDANCE = 'video_pick_for_seedance',
  VIDEO_PICK_FOR_PIXVERSE = 'video_pick_for_pixverse',
  VIDEO_PICK_FOR_KLING = 'video_pick_for_kling',
  VIDEO_PICK_FOR_VEO = 'video_pick_for_veo',
  VIDEO_PICK_FOR_HAILUO = 'video_pick_for_hailuo',
  VIDEO_PICK_FOR_RENDERFOREST_PRO = 'video_pick_for_renderforest_pro',
  VIDEO_PICK_FOR_RENDERFOREST_FAST = 'video_pick_for_renderforest_fast',
  VIDEO_PICK_FOR_SEEDANCE_1_5_PRO = 'video_pick_for_seedance_1_5_pro',
  VIDEO_PICK_FOR_SEEDANCE_2_0 = 'video_pick_for_seedance_2_0',
  VIDEO_PICK_FOR_SEEDANCE_2_0_FAST = 'video_pick_for_seedance_2_0_fast',
  VIDEO_PICK_FOR_PIXVERSE_V5 = 'video_pick_for_pixverse_v5',
  VIDEO_PICK_FOR_PIXVERSE_V6 = 'video_pick_for_pixverse_v6',
  VIDEO_PICK_FOR_PIXVERSE_C1 = 'video_pick_for_pixverse_c1',
  VIDEO_PICK_FOR_KLING_3_OMNI = 'video_pick_for_kling_3_omni',
  VIDEO_PICK_FOR_KLING_3_OMNI_AUDIO = 'video_pick_for_kling_3_omni_audio',
  VIDEO_PICK_FOR_KLING_2_6 = 'video_pick_for_kling_2_6',
  ADD_REF_IMAGE_TO_CHOOSE_STYLE_TOOLTIP = 'add_ref_image_to_choose_style_tooltip',
  MANUAL_EDIT_LABEL = 'manual_edit_label',
  SMART_EDIT_LABEL = 'smart_edit_label',
  SMART_EDIT_PLACEHOLDER = 'smart_edit_placeholder',
  ANIMATE_IMAGE_TITLE = 'animate_image_title',
  ANIMATE_IMAGE_DESCRIPTION = 'animate_image_description',
  CUSTOM_ANIMATE = 'custom_animate',
  DELETE_AI_IMAGE_CONFIRMATION_TITLE = 'delete_ai_image_confirmation_title',
  DELETE_AI_IMAGE_CONFIRMATION_DESCRIPTION = 'delete_ai_image_confirmation_description',
  FLIP_HORIZONTAL_LABEL = 'flip_horizontal_label',
  REF_IMAGE_LABEL = 'ref_image_label',
  REF_IMAGES_LABEL = 'ref_images_label',
  PREPARING_THE_VIDEO = 'preparing_the_video',
  SETTING_UP_THE_SCENES = 'setting_up_the_scenes',
  PLANNING_THE_MOTION = 'planning_the_motion',
  CREATING_THE_VIDEO = 'creating_the_video',
  RENDERING_FRAMES = 'rendering_frames',
  ADDING_MOVEMENT = 'adding_movement',
  PUTTING_IT_TOGETHER = 'putting_it_together',
  FINAL_FRAMES = 'final_frames',
  ALMOST_READY = 'almost_ready',
  FINISHING_THE_VIDEO = 'finishing_the_video',
  DRAMATIC_PAUSE = 'dramatic_pause',
  SO_CLOSE_YOU_CAN_ALMOST_SEE_IT = 'so_close_you_can_almost_see_it',
  OKAY_THIS_ONE_DETAIL_IS_BEING_STUBBORN = 'okay_this_one_detail_is_being_stubborn',
  JUST_PRETENDING_TO_BE_SLOW_NOW = 'just_pretending_to_be_slow_now',
  UPGRADE = 'upgrade',
  TRY_AGAIN_LATER = 'try_again_later',
  PROJECT_DRAFT_LIMIT_REACHED_TITLE = 'project_draft_limit_reached_title',
  PROJECT_DRAFT_LIMIT_REACHED_DESCRIPTION = 'project_draft_limit_reached_description',
  FULL_STORAGE_WARNING = 'full_storage_warning',
  FREEZE_FRAME_LABEL = 'freeze_frame_label',
  EDIT_IMAGE = 'edit_image',
  MAGNET_LABEL = 'magnet_label',
  GEN_AI_ENTRY_BUTTON_LABEL = 'gen_ai_entry_button_label',
  GEN_AI_ENTRY_TOOLTIP = 'gen_ai_entry_tooltip',
  SMART_PROJECT_MATCH = 'smart_project_match',
  SMART_PROJECT_MATCH_DESCRIPTION = 'smart_project_match_description',
  WELCOME_CANVAS_TITLE = 'welcome_canvas_title',
  WELCOME_CANVAS_SUBTITLE = 'welcome_canvas_subtitle',
  AI_HISTORY = 'ai_history',
  QUALITY_LABEL = 'quality_label',
  DURATION_LABEL = 'duration_label',
  FILTER_LABEL = 'filter_label',
  VIEW_ALL_LABEL = 'view_all_label',
  NO_RESULTS_FOUND_LABEL = 'no_results_found_label',
  NO_RESULTS_FOUND_DESCRIPTION_LABEL = 'no_results_found_description_label',
  NO_VIDEO_RESULTS_FOUND_DESCRIPTION = 'no_video_results_found_description',
  NO_IMAGE_RESULTS_FOUND_DESCRIPTION = 'no_image_results_found_description',
  REFERENCE_IMAGES_LABEL = 'reference_images_label',
  VERSION_HISTORY_LABEL = 'version_history_label',
  NO_VERSION_HISTORY_LABEL = 'no_version_history_label',
  COPY_PROMPT_TOOLTIP = 'copy_prompt_tooltip',
  PREVIOUS_LABEL = 'previous_label',
  NEXT_LABEL = 'next_label',
  START_FRAME_LABEL = 'start_frame_label',
  END_FRAME_LABEL = 'end_frame_label',
  UPGRADE_TO_EXPORT_TOOLTIP = 'upgrade_to_export_tooltip',
  OPTIONAL_LABEL = 'optional_label',
  ADD_TEXT_LABEL = 'add_text_label',
  EDIT_YOUR_TEXT_LABEL = 'edit_your_text_label',
  TEXT_BODY_CONTENT_LABEL = 'text_body_content_label',
  TEXT_FONT_LABEL = 'text_font_label',
  TEXT_COLOR_LABEL = 'text_color_label',
  TEXT_SIZE_LABEL = 'text_size_label',
  STROKE_COLOR_LABEL = 'stroke_color_label',
  STROKE_WEIGHT_LABEL = 'stroke_weight_label',
  SELECT_FONT_LABEL = 'select_font_label',
  TEXT_ALIGN_LEFT_LABEL = 'text_align_left_label',
  TEXT_ALIGN_CENTER_LABEL = 'text_align_center_label',
  TEXT_ALIGN_RIGHT_LABEL = 'text_align_right_label',
  Z_ORDER_BRING_TO_FRONT = 'z_order_bring_to_front',
  Z_ORDER_BRING_TO_BACK = 'z_order_bring_to_back',
  Z_ORDER_BRING_FORWARD = 'z_order_bring_forward',
  Z_ORDER_BRING_BACKWARD = 'z_order_bring_backward',
  ALL_LABEL = 'all_label',
  GET_UNLIMITED_GENERATIONS_BANNER = 'get_unlimited_generations_banner',
  GET_UNLIMITED_HD_GENERATIONS_BANNER = 'get_unlimited_hd_generations_banner',
  UPGRADE_UNLIMITED_GENERATIONS_BANNER = 'upgrade_unlimited_generations_banner',
  UNLIMITED_LABEL = 'unlimited_label',
  ORIGINAL_LABEL = 'original_label',
  ORIGINAL_REF_IMAGE_SIZE_SUFFIX_LABEL = 'original_ref_image_size_suffix_label',
  AUTO_RESIZE_REF_IMAGE_TOOLTIP = 'auto_resize_ref_image_tooltip',
  CREDITS_LABEL = 'credits_label',
  REFERENCES_LABEL = 'references_label',
  UP_TO_FILES_LABEL = 'up_to_files_label',
  START_END_FRAME_LABEL = 'start_end_frame_label',
  SUPPORTED_FORMATS_LABEL = 'supported_formats_label',
  POWER_MODE_LABEL = 'power_mode_label',
  POWER_MODE_TOOLTIP = 'power_mode_tooltip',
  POWER_MODE_GENERATING_TITLE = 'power_mode_generating_title',
  POWER_MODE_GENERATING_DESCRIPTION = 'power_mode_generating_description',
  POWER_MODE_GENERATING_DESCRIPTION_FREE = 'power_mode_generating_description_free',
  WAIT_LABEL = 'wait_label',
  TURN_ON_POWER_MODE_LABEL = 'turn_on_power_mode_label',
  CURRENT_FRAME = 'current_frame',
  LAST_FRAME = 'last_frame',
  FADE_IN_LABEL = 'fade_in_label',
  FADE_OUT_LABEL = 'fade_out_label',
  RESIZE_WITH_AI_LABEL = 'resize_with_ai_label',
  RESIZE_LABEL = 'resize_label',
  ENHANCE_QUALITY_LABEL = 'enhance_quality_label',
  ENHANCE_QUALITY_DESCRIPTION = 'enhance_quality_description',
  ENHANCE_LABEL = 'enhance_label'
}

/* AUTO GENERATED FILE. DO NOT MODIFY !!! */
